/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * This is used for the public API - chat messages should only contain this version.
 * @export
 * @interface MediaMinimal
 */
export interface MediaMinimal {
    /**
     * Unique identifier for this media item
     * @type {string}
     * @memberof MediaMinimal
     */
    id: string;
    /**
     * Original filename
     * @type {string}
     * @memberof MediaMinimal
     */
    name: string;
    /**
     * MIME type of the file
     * @type {string}
     * @memberof MediaMinimal
     */
    type: string;
    /**
     * Public URL of this Media
     * @type {string}
     * @memberof MediaMinimal
     */
    url: string;
}

/**
 * Check if a given object implements the MediaMinimal interface.
 */
export function instanceOfMediaMinimal(value: object): value is MediaMinimal {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function MediaMinimalFromJSON(json: any): MediaMinimal {
    return MediaMinimalFromJSONTyped(json, false);
}

export function MediaMinimalFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaMinimal {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'type': json['type'],
        'url': json['url'],
    };
}

export function MediaMinimalToJSON(json: any): MediaMinimal {
    return MediaMinimalToJSONTyped(json, false);
}

export function MediaMinimalToJSONTyped(value?: MediaMinimal | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'type': value['type'],
        'url': value['url'],
    };
}

